import React, { useState } from "react";

import { IconButton, InputAdornment, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { SearchIcon, XIcon } from "./iconography";

const useStyles = makeStyles((theme) => ({
  searchField: {
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(1),
    minWidth: "16rem",
    // maxWidth: "16rem",
  },
  iconButton: {
    marginRight: theme.spacing(-2),
  },
}));

export const SearchField = ({
  handleSearch,
  searchOnChange = false,
  ...props
}) => {
  const classes = useStyles();
  const [searchTerm, setSearchTerm] = useState("");

  const handleChange = (event) => {
    setSearchTerm(event.target.value);
    if (searchOnChange) handleSearch(event.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") event.preventDefault();
  };

  const handleKeyUp = (event) => {
    if (event.key === "Enter") handleSearch(searchTerm);
  };

  const handleReset = () => {
    setSearchTerm("");
    handleSearch("");
  };

  const handleSubmit = () => {
    handleSearch(searchTerm);
  };

  return (
    <TextField
      {...props}
      id="searchTerm"
      value={searchTerm}
      fullWidth
      onChange={handleChange}
      onKeyUp={handleKeyUp}
      onKeyDown={handleKeyDown}
      className={classes.searchField}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton disableRipple onClick={handleReset}>
              <XIcon fontSize="small" className={classes.iconButton} />
            </IconButton>
            <IconButton disableRipple onClick={handleSubmit}>
              <SearchIcon fontSize="small" className={classes.iconButton} />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};
